var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.0859C8.75 11.5501 8.56563 11.9952 8.23744 12.3234C7.90925 12.6516 7.46413 12.8359 7 12.8359C6.53587 12.8359 6.09075 12.6516 5.76256 12.3234C5.43437 11.9952 5.25 11.5501 5.25 11.0859C5.25 10.6218 5.43437 10.1767 5.76256 9.8485C6.09075 9.52031 6.53587 9.33594 7 9.33594C7.46413 9.33594 7.90925 9.52031 8.23744 9.8485C8.56563 10.1767 8.75 10.6218 8.75 11.0859Z",
    fill: "url(#paint0_linear_13007_3469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99864 1.16797C4.58248 1.16797 2.62364 3.1268 2.62364 5.54297V8.01834L1.80581 9.87189C1.76176 9.97177 1.74331 10.0811 1.75216 10.1899C1.761 10.2987 1.79684 10.4036 1.85644 10.495C1.91605 10.5865 1.99752 10.6616 2.09349 10.7136C2.18946 10.7657 2.2969 10.7929 2.40606 10.793H11.5912C11.7004 10.7929 11.8078 10.7657 11.9038 10.7136C11.9998 10.6616 12.0812 10.5865 12.1408 10.495C12.2004 10.4036 12.2363 10.2987 12.2451 10.1899C12.254 10.0811 12.2355 9.97177 12.1915 9.87189L11.3736 8.01834V5.54297C11.3736 3.1268 9.41481 1.16797 6.99864 1.16797Z",
    fill: "url(#paint1_linear_13007_3469)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13007_3469",
    x1: 7,
    y1: 10.586,
    x2: 7.01137,
    y2: 12.8356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD0F",
    stopOpacity: 0.988
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13007_3469",
    x1: 10.9324,
    y1: 9.72343,
    x2: 2.98123,
    y2: 2.5388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD0F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.8eaa51a2d5614d6a2d75ff8061a274c7.svg";
export { ForwardRef as ReactComponent };